var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-echarts',{ref:"vEcharts",style:("width:100%;height:650px"),attrs:{"options":_vm.echartsOptions,"autoresize":"","theme":"light"}})}
var staticRenderFns = []

export { render, staticRenderFns }